import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { BROWSE_PAGE_SIZE } from './runtimeConfigUtils';

const RuntimeConfigGridPagination = ({ count, page, onPageChange }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <TablePagination
      component="div"
      className="runtime-config-table-pagination"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={BROWSE_PAGE_SIZE}
      rowsPerPageOptions={[]}
      onRowsPerPageChange={() => {}}
    />
  );
};

export default RuntimeConfigGridPagination;
